import { ComponentType, h, render } from "preact";

export default class PreactDOMComponent<P> {
    #preactComponent: ComponentType<P>;
    #domContainer: HTMLElement;
    #domNode: HTMLElement | null;
    #props: P | null;

    constructor(preactComponent: ComponentType<P>, domContainer: HTMLElement) {
        this.#preactComponent = preactComponent;
        this.#domContainer = domContainer;
        this.#domNode = null;
        this.#props = null;
    }

    isRendered(): boolean {
        return this.#domNode !== null;
    }

    render(props?: P) {
        this.#props = props ?? {} as P;
        this.#renderComponent();
    }

    update(updatedProps?: Partial<P>) {
        Object.assign(this.#props, updatedProps);
        this.#renderComponent();
    }

    #renderComponent() {
        render(h(
            this.#preactComponent,
            {
                ref: (dom: HTMLElement) => { this.#domNode = dom; },
                ...this.#props!
            }
        ), this.#domContainer);
    }

    remove() {
        render(null, this.#domContainer);
        this.#domNode = null;
        this.#props = null;
    }
}
